import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'sbnb-dialog-widget-preview',
  templateUrl: './dialog-widget-preview.component.html',
  styleUrls: ['./dialog-widget-preview.component.scss'],
})
export class DialogWidgetPreviewComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DialogWidgetPreviewComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      theme: string;
      propertyId: number;
      properties: any[];
    },
    private sanitizer: DomSanitizer
  ) { }

  widgetUrl: SafeResourceUrl;

  ngOnInit(): void {
    this.rebuildWidgetUrl();
  }

  rebuildWidgetUrl() {
    this.widgetUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://booking.hospitable.com/widget/external/${this.dialogData.propertyId}?theme=${this.dialogData.theme}`
    );
  }
}
